import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Button, Modal, TextInput, Theme } from '../../../components';
import { Feedback } from '../../../models';
import { feedbackActions, snackbarActions } from '../../../redux';

import './FeedbackModal.scss';

interface Props {
  closeModal: () => void;
  isOpen: boolean;
}

const FeedbackModal: FC<Props> = ({ isOpen, closeModal }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [feedback, setFeedback] = useState<Feedback>();

  const save = () => {
    dispatch(feedbackActions.AddFeedback({ ...feedback, languageCode: i18n.language }));
    dispatch(snackbarActions.showMessage('SUCCESS', t('feedbackSuccess')));
    setFeedback(null);
    closeModal();
  };

  const handleClose = () => {
    setFeedback(null);
    closeModal();
  };

  return (
    <Modal isOpen={isOpen} title={t('titleFeedbackModal')} closeModal={() => closeModal()} className='modal'>
      <div className='feedback-container'>
        <p className='sub-text'>{t('lblFeedModalIntro')}</p>

        <div className='feedback-container__scores'>
          {['1', '2', '3', '4', '5'].map(rating => (
            <button key={rating} onClick={() => setFeedback(prevState => ({ ...prevState, rating }))} tabIndex={0}>
              <span className={`${feedback?.rating === rating ? 'selected' : ''}`}>{rating}</span>
              <p>{t(`lblFeedbackScore_${rating}`)}</p>
            </button>
          ))}
        </div>

        <TextInput
          type='text-area'
          label={t('lblFeedbackScore')}
          value={feedback?.feedback}
          onChange={(value: string) => setFeedback(prevState => ({ ...prevState, feedback: value }))}
        />

        <div className='buttons'>
          <Button theme={Theme.INVERSE} onClickCallback={handleClose}>
            {t('lblCancel')}
          </Button>
          <Button theme={Theme.SECONDARY} onClickCallback={save} isDisabled={!feedback?.rating}>
            {t('lblSend')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default FeedbackModal;
